export class CreateAndActivateGiftCardResponseDto {
  id: number;
  number: number;
  amount: number;
  customerName: string;
  customerEmail: string;
  active: boolean;

  /**
   * Creates an instance of CreateAndActivateGiftCardResponseDto.
   *
   * @param entity GiftCard Entity.
   */
  static fromEntity(
    entity: Record<string, any> // eslint-disable-line @typescript-eslint/no-explicit-any
  ): CreateAndActivateGiftCardResponseDto {
    /* eslint-enable @typescript-eslint/no-unused-vars */
    const dto = new CreateAndActivateGiftCardResponseDto();
    dto.id = entity?.id || 0;
    dto.number = entity?.number;
    dto.customerName = entity?.customerName || '';
    dto.customerEmail = entity?.customerEmail || '';
    dto.active = entity?.active || false;
    return dto;
  }
}
